import axios from 'axios';
import { useAuthStore } from '../store/auth.store';
import { env } from '../config/env';

export const resolvedBaseUrl = env.apiBaseUrl;
console.log("client js URL", resolvedBaseUrl, "isProd:", env.isProd, ":::::::::::::::::::::::");
export const apiClient = axios.create({
  baseURL: resolvedBaseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Required for httpOnly cookie-based refresh token
});

apiClient.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;
    const errorCode = error.response?.data?.errorCode;

    if (status === 401 && errorCode === 'TOKEN_EXPIRED' && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return apiClient(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Refresh token is sent as httpOnly cookie automatically
        const response = await axios.post(
          `${resolvedBaseUrl}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );
        const { accessToken } = response.data.data;

        useAuthStore.getState().setAccessToken(accessToken);
        processQueue(null, accessToken);
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        useAuthStore.getState().logout();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    const msg = error.response?.data?.message || 'Something went wrong';
    const code = error.response?.data?.errorCode;

    // Deactivated / suspended account → force logout immediately
    if (status === 401 && code === 'AUTHENTICATION_ERROR') {
      useAuthStore.getState().logout();
    }

    return Promise.reject({ message: msg, errors: error.response?.data?.errors || [], status, errorCode: code });
  }
);